export default __webpack_public_path__ + "static/media/sticker-animation-dark@1x.f0a4f5ac.webp";